// CMS public API client for Cryo by Breum
const API_BASE = 'https://api.dev.auxo.dk/public';

/**
 * Optimizes an asset URL via Cloudflare Image Resizing
 */
export function getOptimizedImageUrl(url, { width = 1200, quality = 85, format = 'auto' } = {}) {
  if (!url) return '';
  if (typeof url !== 'string') return '';
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=${format}/`);
}

/**
 * Fetch all items from a CMS collection
 */
export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!res.ok) {
      console.warn(`Failed to fetch CMS collection: ${collectionName}`, res.status);
      return [];
    }
    const data = await res.json();
    return Array.isArray(data) ? data : (data.items || []);
  } catch (err) {
    console.error(`Error fetching collection ${collectionName}:`, err);
    return [];
  }
}

/**
 * Fetch a specific gallery by its slug_id
 */
export async function fetchGalleryBySlug(slugId) {
  try {
    const galleries = await fetchCollection('galleries');
    return galleries.find(g => g.slug_id === slugId || g.slug?._ === slugId || g.slug === slugId) || null;
  } catch (err) {
    console.error(`Error fetching gallery ${slugId}:`, err);
    return null;
  }
}

/**
 * Fetch a treatment by its slug_id
 */
export async function fetchTreatmentBySlug(slugId) {
  try {
    const treatments = await fetchCollection('treatments');
    return treatments.find(t => t.slug_id === slugId || t.slug?._ === slugId || t.slug === slugId) || null;
  } catch (err) {
    console.error(`Error fetching treatment ${slugId}:`, err);
    return null;
  }
}

/**
 * Fetch page content by slug_id
 */
export async function fetchPageBySlug(slugId) {
  try {
    const pages = await fetchCollection('site_pages');
    return pages.find(p => p.slug_id === slugId || p.slug?._ === slugId || p.slug === slugId) || null;
  } catch (err) {
    console.error(`Error fetching page ${slugId}:`, err);
    return null;
  }
}
